export default __webpack_public_path__ + "static/media/DC_unavailable.a3294625.svg";